import { useEffect } from "react";
import { awaitDomElement } from "utils/Helpers";
const SHARE_PARAM = "domId";
export const useTriggerShareByUrl = () => {
  useEffect(() => {
    const urlParams = window.location.search;
    const paramsArr = (urlParams.includes(SHARE_PARAM) && urlParams.split(`${SHARE_PARAM}=`)) || []
    const filterParams = paramsArr?.filter(_param => paramsArr.indexOf(_param) )

    if (filterParams.length) {
      for (const elementId of filterParams) {
        awaitDomElement(`#${elementId}`)
          .then((ele) => {
            ele.click();
            const event = new CustomEvent("shareTriggeredFromDl");
            document.dispatchEvent(event);
            // "deeplinksor"
            window.history.replaceState(null ,'',window.location.href.replace(`${SHARE_PARAM}=${elementId}` , ""))
          })
          .catch((err) => console.log("Cannot get the element", err));
      }
    }
  }, []);
};
